<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FileDisaplaySimples',
})
</script>
<template>
  <Row :gutter="[16, 16]" v-if="files.length">
    <Col v-for="item in files" :key="item.id" v-bind="colAttrs">
      <FileDisplaySimple :record="item" :closeable="closeable" @del="() => $emit('del', item.id!)" />
    </Col>
  </Row>
</template>

<script lang="ts" setup name="FileDisaplaySimples">
import { Col, Row } from 'ant-design-vue'
import { fileDisplaySimplesProps } from './props'
import FileDisplaySimple from './Simple.vue'

defineProps(fileDisplaySimplesProps)
defineEmits<{
  (e: 'del', id: string): void
}>()
</script>
